import data from "../data";

export function item(catId, id) {
	const cat = data.find((x) => x.id === catId);
	return cat ? cat.items.find((x) => x.id === id) : null;
}

export function res() {
	return window.innerWidth <= 740 ? true : false;
}
